/**
 * @file: ChatRefusalNotice.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { ChatRefusal } from '@euler/app/flows/chat/lib/session/client';
import { EmptyView } from '@euler/components/EmptyView';
import { FeatureNotEnabledView } from '@euler/components/entitlements/FeatureNotEnabledView';
import { StoreFeature } from '@euler/model/enum';
import { memo } from 'react';

/** What the chat list shows once the gateway refused the store for good. */
export const ChatRefusalNotice = memo(
  ({ refusal }: { refusal: ChatRefusal }) =>
    refusal === 'store_feature_not_enabled' ? (
      <FeatureNotEnabledView feature={StoreFeature.Chat} />
    ) : (
      <EmptyView message="门店服务到期,请联系服务人员" />
    ),
);
